var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{staticClass:"gallery-modal",attrs:{"name":_vm.name,"width":"100%","height":"100%"}},[_c('div',{staticClass:"gallery-modal__body"},[_c('close-btn',{on:{"click":function($event){return _vm.$modal.hide(_vm.name)}}}),_c('img',{staticClass:"gallery-modal__image",attrs:{"src":_vm.image}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }